const initialState = [];

function residencesReducer(state = initialState, action) {
  switch (action.type) {
    case "residences/update":
      return action.payload;
    case "residences/delete":
      return state.filter(
        (residence) => !action.payload.includes(residence.id)
      );
    default:
      return state;
  }
}

export default residencesReducer;
